// extracted by mini-css-extract-plugin
module.exports = {"companies-container":"ScoopCompanies_companies-container__3JwZ6","company":"ScoopCompanies_company__u3J7h"};